// extracted by mini-css-extract-plugin
export default {"respTable":"AdminManageChurches_respTable__tZ6EP","respTableCell":"AdminManageChurches_respTableCell__5Lf-7"};